export default __webpack_public_path__ + "static/media/document-logo-5.d43a5e56.svg";